module.exports = __webpack_public_path__ + "static/media/flower-12.d41ab903.svg";